module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/instagram-icon-solid-ffda1431475ad57f294e691beecc0320.png";